import * as React from "react";
const SvgBulletpointL = (props) => (React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("g", { id: "Size=32" },
        React.createElement("path", { id: "Circle", d: "M12 16C12 18.2091 13.7909 20 16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16Z", fill: "currentColor" }))));
export default SvgBulletpointL;
//# sourceMappingURL=bulletpoint-l.svg.js.map